import 'css-chunk:../components/tooltip/index.module.scss';export default {
  "tooltip": "_tooltip_1va86_1"
};